const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "video game") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M113.411,374.774c-3.933,0-9.385-4.427-14.585-11.845C87.784,347.179,78.905,320.81,75.074,292.4c-4.461-33.092-1.6-65.978,8.053-92.6,10.486-28.919,23.286-52.656,37.5-70.006a58.77,58.77,0,0,0-7.029,2.738c-27.32,12.74-52.347,47.283-70.471,97.268-9.654,26.62-12.514,59.506-8.053,92.6,3.831,28.415,12.71,54.784,23.752,70.534,5.2,7.418,10.652,11.845,14.585,11.845,11.365,0,26.4-10.579,43.552-30.333A20.7,20.7,0,0,1,113.411,374.774Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.579,119.812c-16.091-7.5-32.917-8.269-48.655-2.52C340.3,122.993,328.037,136,320.237,155H192.076c-7.793-19-20.057-31.975-35.683-37.68-15.76-5.756-32.605-4.908-48.712,2.6C76.967,134.245,49.366,171.56,29.965,225.065,6.4,290.054,24.926,368.982,47.363,400.986c8.168,11.65,17.175,17.8,26.048,17.8,21.274,0,47.078-21.732,76.7-64.585a612.23,612.23,0,0,0,34.822-57.5c11.935,6.029,38.8,17.527,70.075,17.527a158.8,158.8,0,0,0,72.463-17.383,610.388,610.388,0,0,0,34.743,57.288c29.618,42.805,55.422,64.509,76.694,64.509,8.426,0,16.776-5.817,24.818-17.287C486.53,368.818,505.693,289.466,482.35,225.1,462.928,171.532,435.309,134.143,404.579,119.812ZM476.584,322.8c-4.07,27.9-13.392,54.913-24.326,70.51-5.854,8.349-10.736,11.324-13.354,11.324-15.906,0-39-20.685-65.021-58.244a591.254,591.254,0,0,1-37.292-62.316,7.009,7.009,0,0,0-10.147-2.773c-.287.189-29.279,18.918-71.44,18.918-37.45,0-69.041-18.869-69.349-19.055a7.015,7.015,0,0,0-9.927,2.9,593.19,593.19,0,0,1-37.29,62.385c-26.028,37.608-49.121,58.318-65.027,58.318-3.933,0-9.385-4.427-14.585-11.845C47.784,377.179,38.905,350.81,35.074,322.4c-4.461-33.092-1.6-65.978,8.053-92.6,18.124-49.985,43.151-84.528,70.471-97.268a51.441,51.441,0,0,1,21.858-5.129,46.75,46.75,0,0,1,16.135,2.91c13.018,4.752,22.8,16.258,29.083,33.879A7.149,7.149,0,0,0,187.268,169H325.047a7.149,7.149,0,0,0,6.594-4.811c6.2-17.395,16.256-29.145,29.086-33.827,12.343-4.511,25.108-3.8,37.935,2.179,27.335,12.746,52.381,47.305,70.526,97.347C481.54,263.948,480.027,299.206,476.584,322.8Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.25,191.79a19,19,0,1,0,19-19.045A19.044,19.044,0,0,0,373.25,191.79Zm24,0a5,5,0,1,1-5-5.045A5.029,5.029,0,0,1,397.25,191.79Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.25,237.989a19.046,19.046,0,1,0,19,19.046A19.044,19.044,0,0,0,392.25,237.989Zm0,24.091a5.046,5.046,0,1,1,5-5.045A5.028,5.028,0,0,1,392.25,262.08Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.75,205.367a19.046,19.046,0,1,0,19,19.046A19.044,19.044,0,0,0,359.75,205.367Zm0,24.091a5.046,5.046,0,1,1,5-5.045A5.028,5.028,0,0,1,359.75,229.458Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.75,205.367a19.046,19.046,0,1,0,19,19.046A19.044,19.044,0,0,0,424.75,205.367Zm0,24.091a5.046,5.046,0,1,1,5-5.045A5.028,5.028,0,0,1,424.75,229.458Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,204H141V179.745A6.787,6.787,0,0,0,134,173H106a6.787,6.787,0,0,0-7,6.745V204H75a6.884,6.884,0,0,0-7,6.862v28.105A7.028,7.028,0,0,0,75,246H99v23.08a6.932,6.932,0,0,0,7,6.92h28a6.932,6.932,0,0,0,7-6.92V246h23a7.028,7.028,0,0,0,7-7.033V210.862A6.884,6.884,0,0,0,164,204Zm-7,28H134a6.972,6.972,0,0,0-7,6.967V262H113V238.967A6.972,6.972,0,0,0,106,232H82V218h24a7.118,7.118,0,0,0,7-7.138V187h14v23.862A7.118,7.118,0,0,0,134,218h23Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,212a7,7,0,0,0-7-7H227a7,7,0,0,0-7,7v25a7,7,0,0,0,7,7h58a7,7,0,0,0,7-7Zm-14,18H234V219h44Z",
    style: {
      fill: "#2eca8b"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame);
export default __webpack_public_path__ + "static/media/game.ac1e3cf4c5696f78d51857724ddeada7.svg";
export { ForwardRef as ReactComponent };